export enum ClientPlanType {
  HYBRID_PLAN = 'HYBRID_PLAN',
  PREMIUM_PLAN = 'PREMIUM_PLAN',
  CUSTOM_PLAN = 'CUSTOM_PLAN',
  B2B_PLAN = 'B2B_PLAN',
  B2C_PLAN = 'B2C_PLAN',
}

export enum ClientPlanTypeEnum {
  Hybrid = 0,
  Premium = 1,
  Custom = 2,
  B2b = 3,
  B2c = 4,
}